import manualInvoiceItems from "./manualInvoiceItems.component";
import manualInvoiceItemsUrls from "./manualInvoiceItems.urls";
import ManualInvoiceItemsTransforms from "./manualInvoiceItems.transforms";

const manualInvoiceItemsModule = angular
  .module("app.components.manualInvoiceItems", [])
  .component("manualInvoiceItemsPage", manualInvoiceItems)
  .service("ManualInvoiceItemsTransforms", ManualInvoiceItemsTransforms)
  .config(manualInvoiceItemsUrls);

export default manualInvoiceItemsModule;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItems/manualInvoiceItems.module.js